import script from "./MobilePageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobilePageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MobilePageHeader.vue?vue&type=style&index=0&id=36b2aeb4&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b2aeb4"]])

export default __exports__